import styled from 'styled-components';
import { rem } from 'polished';
import { Device } from '../../utils';

export const SuccessMessageContainer = styled.div`
    .success-message {
        font-size: ${rem('16px', 16)};
        color: ${({ theme }) => theme.secondaryLinkActiveColor};
        flex-grow: 2;

        @media (max-width: ${Device.tablet}) {
            font-size: ${rem('14px', 16)};
        }

        &__outer-container {
            display: flex;
            justify-content: center;
        }

        &__inner-container {
            align-items: center;
            background-color: #ecf3fa;
            border: ${rem('2px', 16)} solid ${({ theme }) => theme.primaryButtonBaseColor};
            color: white;
            display: flex;
            gap: ${rem('12px', 16)};
            padding: ${rem('10px', 16)};
            width: 100%;
        }

        &__icon {
            span {
                display: flex;
                align-items: center;
                justify-content: center;

                svg {
                    height: ${rem('16px', 16)};
                    width: ${rem('16px', 16)};
                    rect[id*='info'] {
                        fill: ${({ theme }) => theme.primaryButtonBaseColor};
                        fill-opacity: 1;
                    }
                }
            }
        }

        &__title {
            font-weight: 800;
        }

        &__close {
            cursor: pointer;

            span {
                display: flex;
                align-items: center;
                justify-content: center;

                svg {
                    width: ${rem('14px', 16)};
                    height: ${rem('14px', 16)};

                    rect {
                        fill: ${({ theme }) => theme.secondaryLinkActiveColor};
                    }
                }
            }
        }
    }
`;
